import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { useMenu } from '@/context/MenuContext';
import { findFirstPath } from '@/lib/menuUtils';

/**
 * 현재 위치 표시. depth 가 3단 이상으로 늘어나면 길찾기에 필수적이다.
 */
const Breadcrumbs = () => {
  const { breadcrumb } = useMenu();

  if (!breadcrumb.length) return null;

  return (
    <nav
      aria-label="현재 위치"
      className="flex items-center gap-1 overflow-x-auto whitespace-nowrap px-1 text-xs text-app-muted scrollbar-hide"
    >
      <Link to="/dashboard" className="flex items-center gap-1 hover:text-brand" title="홈">
        <Home size={13} />
      </Link>

      {breadcrumb.map((node, index) => {
        const isLast = index === breadcrumb.length - 1;
        const to = findFirstPath(node);

        return (
          <React.Fragment key={node.menuId}>
            <ChevronRight size={12} className="shrink-0 text-app-faint" />
            {isLast || !to ? (
              <span className="font-semibold text-app-text">{node.menuName}</span>
            ) : (
              <Link to={to} className="hover:text-brand">{node.menuName}</Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
